<template>
    <StarRating
        :increment="0.5"
        :show-rating="false"
        :rating="rating"
        :read-only="readOnly"
        :star-size="20"
        @rating-selected="rateUser"
    ></StarRating>
</template>

<script>
export default {
    components: {
        StarRating: () => import(/* webpackChunkName: "lazy-loaded/vue-star-rating" */ 'vue-star-rating')
    },

    props: {
        rating: {
            type: Number,
            required: true
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        rateUser(rating) {
            this.$emit('input', rating);
        }
    }
};
</script>

<style>
.vue-star-rating-star {
    line-height: 0;
}
</style>
